var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"imageWrap"},[_c('van-image',{attrs:{"fit":"cover","error-icon":"","loading-icon":"","width":_vm.imageSize + 'px',"height":_vm.imageSize + 'px',"src":_vm.getGoodsImageUrl()}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }